import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Field, formConsumer, FormGroup, Slider } from 'core/form';
import DimensionSelector from 'app/components/dimensions/DimensionSelector';
import { Box, FlexColumn, Text } from 'core/components';

const MIN_LIMIT = 10;
const MAX_LIMIT = 1000;
const STEP_SIZE = 5;

@formConsumer
@observer
class EventViewerOptions extends Component {
  render() {
    const { disabledDimensions, isEditingDimensions, onEditComplete } = this.props;
    return (
      <FlexColumn gap={2}>
        <Box>
          <DimensionSelector
            title="Dimensions"
            showClearButton
            fieldName="rawLegend.dimensions"
            isEditing={isEditingDimensions}
            onEditComplete={onEditComplete}
            disabledValues={disabledDimensions}
            showEditButton
            small
          />
        </Box>
        <Field name="rawLegend.limit" mb={0}>
          {({ field, name, ...rest }) => (
            <FormGroup labelFor={`field-${name}`} {...rest} label={<Text small>{field.label}</Text>}>
              <Box px="12px">
                <Slider
                  {...rest}
                  min={MIN_LIMIT}
                  max={MAX_LIMIT}
                  stepSize={STEP_SIZE}
                  labelStepSize={MAX_LIMIT - MIN_LIMIT}
                />
              </Box>
            </FormGroup>
          )}
        </Field>
      </FlexColumn>
    );
  }
}

export default EventViewerOptions;
